import { render, staticRenderFns } from "./coordinatesData.vue?vue&type=template&id=7e724863&scoped=true"
import script from "./coordinatesData.vue?vue&type=script&lang=js"
export * from "./coordinatesData.vue?vue&type=script&lang=js"
import style0 from "./coordinatesData.vue?vue&type=style&index=0&id=7e724863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e724863",
  null
  
)

export default component.exports